import { Flex, Spinner } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMoralisCloudFunction } from 'react-moralis';
import { colors } from 'src/utils/colors';
import { useMarketProvider } from '../../../providers/Market/marketProvider';
import { t } from 'i18next';

export const HashupInfo = () => {
	const { playersCount } = useMarketProvider();

	const items = useMemo(() => {
		return [
			{
				title: t('hashupInfo.allGamers'),
				value: playersCount,
			},
			{
				title: t('hashupInfo.price'),
				value: '$0.05',
			},
			{
				title: t('hashupInfo.marketCap'),
				value: '#####',
			},
		];
	}, [playersCount]);

	return (
		<Flex gridGap="20px">
			{items.map((el, index) => {
				return (
					<Flex
						key={index}
						alignItems="center"
						fontSize="12px"
						color="white"
						fontWeight="bold"
						justifyContent="center"
						gridGap="10px"
					>
						{el.title}:
						<Flex
							fontWeight="normal"
							color={colors.primary}
							alignItems="center"
						>
							{el.value ? (
								el.value
							) : (
								<Spinner
									h="12px"
									w="12px"
								/>
							)}
						</Flex>
					</Flex>
				);
			})}
		</Flex>
	);
};
